<template>
  <div class="d-flex justify-center" :style="{ padding: '10px' }">
    <v-card
      class="d-flex pa-2 flex-column align-center justify-center"
      outlined
      :style="{
        'margin-bottom': '40px',
        width: '80%',
        'min-height': '550px',
        height: 'fit-content',
      }"
      elevation="2"
    >
      <h3 class="ma-2 text-center">Bulk Upload - Insert Transaction Off Us</h3>
      <div
        class="d-flex flex-row justify-center align-center flex-wrap"
        :style="{
          'text-align': 'center',
          width: '85%',
          padding: '50px 0px 50px 0px',
        }"
      >
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
        >
          <v-row align="center" class="ma-1" style="width: 60%">
            <v-file-input
              label="Data Transaction (.xlsx)"
              placeholder="Select your files"
              :accept="validate.file_bulk_merchant.type.join()"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-paperclip"
              prepend-icon=""
              v-model="fileBulkMerchant"
              @click="clearLastResult()"
              @focus="fileBulkMerchantFocus += 1"
              :error-messages="fileBulkMerchantErrors"
              @change="$v.fileBulkMerchant.$touch()"
              @blur="$v.fileBulkMerchant.$touch()"
            />
          </v-row>
          <v-row v-if="onUpload" style="width: 60%" class="mb-5">
            <h4>Uploading..</h4>
            <v-progress-linear
              v-model="uploadProgress"
              :active="onUpload"
              :query="true"
            />
          </v-row>
          <v-row v-if="onInsert" style="width: 60%" class="mb-5">
            <h4>{{ insertName }}</h4>
            <v-progress-linear
              v-model="insertProgress"
              :active="onInsert"
              :query="true"
            />
          </v-row>

          <v-row v-if="loading" style="width: 60%" class="mb-5">
            <h4>Generating download file..</h4>
            <v-progress-linear :indeterminate="loading" />
          </v-row>
          <v-row
            class="d-flex flex-column justify-center mb-5"
            v-if="hasFailedImport"
            style="width: 60%"
          >
            <v-card
              class="d-flex flex-column text-left pa-5"
              style="font-size: 13px"
            >
              <h3>Last result :</h3>
              <div style="color: green">
                {{ countSuccess }} record berhasil !
              </div>
              <div style="color: red; margin-bottom: 10px">
                {{ countFailed }} record gagal !
              </div>
              <div class="text--primary">
                Klik
                <a
                  v-if="!loadingDownloadFailed"
                  @click="downloadFailed"
                  @keydown.enter="downloadFailed"
                  >Download</a
                >
                <span v-else>Downloading...</span>
                untuk mengunduh data yang gagal kedalam file .xls
              </div>
            </v-card>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-select
                v-model="selectedSwitcher"
                :items="switcherOptions"
                label="Select Template"
                outlined
                dense
                class="mb-4"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-btn
                small
                color="primary"
                @click="downloadBaseTemplate"
                :loading="loadingDownloadTemplate"
                :disabled="loadingDownloadTemplate"
              >
                Download Template
              </v-btn>
            </v-col>
          </v-row>
          <v-row align="center" class="mb-4 mt-2">
            <v-btn
              small
              color="success"
              :disabled="onUpload || onInsert"
              :loading="onUpload || onInsert"
              @click="upload"
              :style="{ margin: '5px' }"
            >
              Upload
              <v-icon right dark> mdi-cloud-upload </v-icon>
            </v-btn>
          </v-row>
        </div>
      </div>

      <template>
        <p class="text-justify text-caption">
          Note:<br />
          Maximum 10.000 rows to insert transaction data.
        </p>
      </template>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { validations } from '../../store/params';
import { date } from '../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    fileBulkMerchant: {
      required() {
        if (this.fileBulkMerchantFocus > 1) {
          return this.fileBulkMerchant != null;
        }
        return true;
      },
      fileType() {
        if (this.fileBulkMerchant != null) {
          return !!validations.file_bulk_merchant.type.includes(
            this.fileBulkMerchant.type.toLowerCase()
          );
        }
        return true;
      },
    },
  },
  mounted() {
    this.$store.commit('insertTransaction/clearLastResult');
  },
  data() {
    return {
      validate: validations,
      fileBulkMerchant: null,
      loadingDownloadTemplate: false,
      loadingDownloadFailed: false,
      fileBulkMerchantFocus: 0,
      searchMerchant: '',
      loadingDownloadFile: false,
      selectedSwitcher: 'artajasa',
      switcherOptions: [
        { text: 'Artajasa', value: 'artajasa' },
        { text: 'Rintis', value: 'rintis' }
      ],
    };
  },

  computed: {
    loading() {
      return this.$store.state.insertTransaction.loading;
    },
    uploadProgress() {
      return this.$store.state.insertTransaction.uploadProgress;
    },
    onUpload() {
      return this.$store.state.insertTransaction.onUpload;
    },
    insertProgress() {
      return this.$store.state.insertTransaction.insertProgress;
    },
    insertName() {
      return this.$store.state.insertTransaction.insertName;
    },
    onInsert() {
      return this.$store.state.insertTransaction.onInsert;
    },
    countSuccess() {
      return this.$store.state.insertTransaction.countSuccess;
    },
    countFailed() {
      return this.$store.state.insertTransaction.countFailed;
    },
    hasFailedImport() {
      return this.$store.state.insertTransaction.hasFailedImport;
    },
    fileBulkMerchantErrors() {
      const errors = [];
      if (!this.$v.fileBulkMerchant.$dirty) return errors;
      if (!this.$v.fileBulkMerchant.required)
        errors.push('File Data Transaction is required for upload');
      if (!this.$v.fileBulkMerchant.fileType)
        errors.push('Incorrect filetype Data Transaction File');
      return errors;
    },
  },
  methods: {
    async downloadFailed() {
      this.loadingDownloadFailed = true;
      try {
        const response = await this.$store.dispatch(
          'insertTransaction/downloadFailedImport'
        );
        if (response) {
          const blob = new Blob([response.data]);
          const fileUrl = URL.createObjectURL(blob);
          const contentDisposition =
            response.headers['content-disposition'] || '';
          const fileNameMatch = contentDisposition.match(
            /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
          );
          const fileName = fileNameMatch
            ? decodeURIComponent(fileNameMatch[1])
            : 'failed-import-transaction.xlsx';
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl);
        }
      } finally {
        this.loadingDownloadFailed = false;
      }
    },
    async downloadBaseTemplate() {
      this.loadingDownloadTemplate = true;
      try {
        const response = await this.$store.dispatch(
          'insertTransaction/downloadTemplate',
          this.selectedSwitcher
        );
        if (response) {
          const blob = new Blob([response.data]);
          const fileUrl = URL.createObjectURL(blob);
          const contentDisposition =
            response.headers['content-disposition'] || '';
          const fileNameMatch = contentDisposition.match(
            /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
          );
          const fileName = fileNameMatch
            ? decodeURIComponent(fileNameMatch[1])
            : `template-${this.selectedSwitcher}.xlsx`;
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl);
        }
      } finally {
        this.loadingDownloadTemplate = false;
      }
    },
    upload() {
      this.$store.commit('insertTransaction/clearLastResult');
      this.fileBulkMerchantFocus = 2;
      this.$v.fileBulkMerchant.$touch();
      if (!this.$v.fileBulkMerchant.$error) {
        this.$store.dispatch('insertTransaction/bulkUpload', {
          file: this.fileBulkMerchant,
          date,
        });
      }
    },
    clearLastResult() {
      this.$store.commit('insertTransaction/clearLastResult');
    },
  },
};
</script>
